export default {
  socket : null
}
